async function getBroadcastDate(date) {
	return await fetch(`/schedule/${date}`, {
		method: 'POST',
	})
		.then((res) => res.json())
		.catch((err) => err.json())
}

async function getBroadcastFutureDate(date) {
	return await fetch(`/future-schedule/${date}`, {
		method: 'POST',
	})
		.then((res) => res.json())
		.catch((err) => err.json())
}

export async function checkBroadcastDates(minDate, maxDate) {
	return await fetch(`/schedule/exists/${minDate}:${maxDate}`, { method: 'GET' }).then((res) => res.json())
		.catch((err) => err.json())
}

export async function renderMainSchedule(date, slider) {
	const broadcastDay = await getBroadcastFutureDate(date)
	const { schedule } = broadcastDay

	schedule.forEach((program) => {
		const broadcastItem = `
      <div class="carousel__item item swiper-slide" data-time="${program.time}">
        <div class="on-air-unit ">
          <div class="on-air-unit__time">${program.time}</div>
          <div class="on-air-unit__title">${program.telecast.title}</div>
        </div>
      <div>`

		slider.appendSlide(broadcastItem)
	})
}

const renderTVShows = (schedule) => {
	const scheduleList = document.querySelector('.section--teleprogram .schedule-list')
	const banner = document.querySelector('.section--teleprogram .banner')
	document.querySelectorAll('.schedule-list > div').forEach((show) => show.remove())

	schedule.forEach((program, id) => {
		const { title, ageRating, country, genre } = program.telecast
		let { episode } = program
		if (episode) {
			episode.split('').includes('-') ? (episode += ' серии') : (episode += ' серия')
		}
		const description = [episode ? episode : null, country, genre].filter((el) => el !== null)
		const broadcastItem = document.createElement('div')
		broadcastItem.classList.add('schedule-article')
		broadcastItem.innerHTML = `
      <div class="schedule-article__info">
        <div class="schedule-article__time">${program.time}</div>
        <div class="schedule-article__data">
          <div class="schedule-article__title">${title}</div>
          <div class="schedule-article__text">${description.length > 0 ? description.join(', ') : ''}</div>
        </div>
      </div>
      <div class="schedule-article__system">
        <div class="schedule-article__age">${ageRating}+</div>
      </div>`
		scheduleList.append(broadcastItem)
	})
}

export async function showProgram(date) {
	const broadcastDays = await getBroadcastDate(date)
	const { schedule } = broadcastDays
	renderTVShows(schedule)
}

